/* eslint-disable no-restricted-globals */
import {
  formatPhoneNumber,
  restrictInvalidCharacters,
  iosSelectmenuAccessibilityFixes
} from '../utilities/utility';
import { selectmenuAccessibilityCompliance } from '../utilities/helper';
import { API_REFERENCE } from '../utilities/constant_api';
import { formPost, formPostJsonResponse } from '../components/ajax';
$(function() {
  const removeAuthorizedContactUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.accountAuthorizedContacts.removeAuthorizedContact}`;
  let saveAuthContactAjaxReq = true;
  let removeAuthContactFormAjaxReq = true;
  let removeAuthContactNumberAjaxReq = true;
  var menuHidden = true;
  const authorizedZeroContact =
    'Authorized contacts are trusted people who you have given permission to help manage your account.';

  function accountMenuDeselect() {
    $('.accountMenuHead').removeClass('account-menu-selected');
    $('.accountMenuTail').removeClass('account-menu-selected-tail');
    $(this)
      .find('.accountMenuHead')
      .addClass('account-menu-selected');
    $(this)
      .find('.accountMenuTail')
      .addClass('account-menu-selected-tail');
  }

  function accountMenuHeadHighlight(head) {
    $(head).addClass('account-menu-selected');
  }

  function accountMenuTailHighlight(tail) {
    $(tail).addClass('account-menu-selected-tail');
  }

  accountMenuDeselect();
  const sanitizedWindowLocationPathName = window.location.pathname;
  if (sanitizedWindowLocationPathName.indexOf('trackOrder') !== -1) {
    accountMenuHeadHighlight('.trackOrder .accountMenuHead');
    accountMenuTailHighlight('.trackOrder .accountMenuTail');

    if ($(window).width() <= 480) {
      $('.accountHeaderText .label').text('Track Orders');
    }
  }

  if (sanitizedWindowLocationPathName.indexOf('reorderSupplies') !== -1) {
    accountMenuHeadHighlight('.reorderSupplies .accountMenuHead');
    accountMenuTailHighlight('.reorderSupplies .accountMenuTail');

    if ($(window).width() <= 480) {
      $('.accountHeaderText .label').text('Reoder Supplies');
    }
  }

  if (sanitizedWindowLocationPathName.indexOf('accountSettings') !== -1) {
    accountMenuHeadHighlight('.accountSettings .accountMenuHead');
    accountMenuTailHighlight('.accountSettings .accountMenuTail');
  }

  if (sanitizedWindowLocationPathName.indexOf('addressBook') !== -1) {
    accountMenuHeadHighlight('.addressBook .accountMenuHead');
    accountMenuTailHighlight('.addressBook .accountMenuTail');

    if ($(window).width() <= 480) {
      $('.accountHeaderText .label').text('Address Book');
    }
  }

  if (sanitizedWindowLocationPathName.indexOf('billingAndPayments') !== -1) {
    accountMenuHeadHighlight('.billingAndPayments .accountMenuHead');
    accountMenuTailHighlight('.billingAndPayments .accountMenuTail');

    if ($(window).width() <= 480) {
      $('.accountHeaderText .label').text('Billing and Payments');
    }
  }

  if (
    sanitizedWindowLocationPathName.indexOf('insuranceDoctorsAndConditions') !==
    -1
  ) {
    accountMenuHeadHighlight('.insuranceDoctorsAndConditions .accountMenuHead');
    accountMenuTailHighlight('.insuranceDoctorsAndConditions .accountMenuTail');

    if ($(window).width() <= 480) {
      $('.accountHeaderText .label').text('Insurance, Doctors and Conditions');
    }
  }

  if (sanitizedWindowLocationPathName.indexOf('myDocuments') !== -1) {
    accountMenuHeadHighlight('.myDocuments .accountMenuHead');
    accountMenuTailHighlight('.myDocuments .accountMenuTail');

    if ($(window).width() <= 480) {
      $('.accountHeaderText .label').text('My Documents');
    }
  }

  if (sanitizedWindowLocationPathName.indexOf('notifications') !== -1) {
    accountMenuHeadHighlight('.notifications .accountMenuHead');
    accountMenuTailHighlight('.notifications .accountMenuTail');

    if ($(window).width() <= 480) {
      $('.accountHeaderText .label').text('Notifications');
    }
  }

  function toggleAccountMenu() {
    if (menuHidden) {
      $('.accountLinks').removeClass('hidden');
      $('.accountLinks').addClass('show');
      menuHidden = !menuHidden;
    } else if (!menuHidden) {
      $('.account-menu-container').removeClass('show');
      $('.account-menu-container').addClass('hidden');
      menuHidden = !menuHidden;
    }
  }

  function setAccountMenuActive() {
    if ($(window).width() <= 480) {
      $('.accountHeaderText').text($('.breadcrumb .active a').text());
      toggleAccountMenu();
    }
  } // edit a contact

  function editBtn(e) {
    e.preventDefault();

    var contactBtns = $(e.currentTarget)
      .closest('.view-authorized-contact')
      .children()
      .last();
    contactBtns.find('.remove-form').removeClass('hidden');
    var editContacts = $(e.currentTarget)
      .closest('.authorized-contact')
      .next();
    var saveButton = $(Object.values(contactBtns.children().last())[0]);
    var contactRelation = $(e.currentTarget)
      .parents('.authorized-contact')
      .find('.contact-relation')
      .text();
    var contactName = $(e.currentTarget)
      .parents('.authorized-contact')
      .find('.contact-name')
      .text();
    var contactNumber = $(e.currentTarget)
      .parents('.authorized-contact')
      .find('.contact-phone')
      .text();

    contactNumber = contactNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1.$2.$3');
    var splittedName = contactName.split(' ');
    var fName = splittedName[0];
    var lName = splittedName[1];

    if (
      !$(e.currentTarget)
        .closest('.authorized-contact')
        .hasClass('hidden')
    ) {
      $(e.currentTarget)
        .closest('.authorized-contact')
        .addClass('hidden');
      $(editContacts).addClass('hidden');
    }
    if (editContacts.find('.edit-contact').hasClass('hidden')) {
      editContacts.find('.edit-contact').removeClass('hidden');
    }

    if ($(editContacts).hasClass('hidden')) {
      $(editContacts).removeClass('hidden');
      $(editContacts)
        .find('.edit-contact')
        .find('.fname')
        .val(fName);
      $(editContacts)
        .find('.edit-contact')
        .find('.lname')
        .val(lName);
      $(editContacts)
        .find('.edit-contact')
        .find('.contact-phone-number')
        .val(contactNumber);
      $(editContacts)
        .find('.edit-contact')
        .find('select')
        .val(contactRelation);
    }
    $('.edit-contact .contact-relation').selectmenu({
      classes: {
        'ui-selectmenu-button': 'col-xs-12 col-sm-12 mt-2 selectmenu-relation'
      }
    });
    if (contactBtns.hasClass('hidden')) {
      contactBtns.toggleClass('hidden');
    }
    selectmenuAccessibilityCompliance();
  } // changing into phone number format

  function changeNumber(e) {
    var key = e.charCode || e.keyCode || 0;
    var $text = $(this);

    if (key !== 8 && key !== 9) {
      if ($text.val().length === 3) {
        var tempStr = '';
        var addedDash = tempStr.concat($text.val(), '.');
        $text.val(addedDash);
      }

      if ($text.val().length === 7) {
        var _tempStr = '';

        var _addedDash = _tempStr.concat($text.val(), '.');

        $text.val(_addedDash);
      }
    }

    return (
      key === 8 ||
      key === 9 ||
      key === 46 ||
      (key >= 48 && key <= 57) ||
      (key >= 96 && key <= 105)
    );
  } // changes the number of contacts based on the number of entries in the form

  function editContactAmount() {
    var contactAmt = $('.authorized-contact').length - 1;
    var headerText = $('.authorized-contacts-header-text').text();

    if (contactAmt > 0) {
      if (headerText.length !== 19) {
        var newText = headerText.replace(headerText.charAt(21), contactAmt);
        $('.authorized-contacts-header-text').text(newText);
      } else {
        var text = $('.authorized-contacts-header-text')
          .text()
          .concat(' (', contactAmt, ')');
        $('.authorized-contacts-header-text').text(text);
      }
    } else {
      var defaultText = headerText.substring(0, 19);
      $('.authorized-contacts-header-text').text(defaultText);
    }
  } // cancel writing the form

  function cancelBtn(e) {
    e.preventDefault();
    var parent = $(e.currentTarget).parents('.view-authorized-contact');
    parent.find('.authorized-contact').each(function(field) {
      var viewField = $(parent.find('.authorized-contact')[field]);

      if (viewField.hasClass('hidden')) {
        viewField.toggleClass('hidden');
      }
    });
    parent.find('.account-information').each(function(field) {
      var editField = $(parent.find('.account-information')[field]);

      if (editField.find('.authorizedContactId').val() === '') {
        editField.prev().addClass('hidden');
        editField.prev().remove();
        editField.addClass('hidden');
        editField.remove();
      }

      editField.addClass('hidden');
    });
    $('.account-information-edit-mode').addClass('hidden');

    if (!$(parent.find('.edit-contact-btns')).hasClass('hidden')) {
      $(parent.find('.edit-contact-btns')).toggleClass('hidden');
    }
  } // save contact info helper function

  function saveContactInfo(e, inputFields, viewFields) {
    e.preventDefault();
    var contactAmt = $('.authorized-contact').length;
    contactAmt = contactAmt - 1;
    $('.authorized-contacts-header-text').text(
      'Authorized Contacts (' + contactAmt + ')'
    );
    Object.values(inputFields.find('.contact-field')).forEach(function(field) {
      var formField;
      if ($(field).find('.ui-selectmenu-button').length > 0) {
        formField = $(field)
          .find('select')
          .val();
      } else {
        formField = $(field)
          .children()
          .last()
          .val();
      }

      if (
        $(field)
          .children()
          .last()
          .prev()
          .hasClass('fname')
      ) {
        viewFields.find('.contact-name').text(
          $(field)
            .children()
            .last()
            .prev()
            .val()
        );
      } else if (
        $(field)
          .children()
          .last()
          .prev()
          .hasClass('lname')
      ) {
        viewFields.find('.contact-name').text(
          viewFields.find('.contact-name').text() +
            ' ' +
            $(field)
              .children()
              .last()
              .prev()
              .val()
        );
      } else if (
        $(field)
          .children()
          .last()
          .prev()
          .hasClass('contact-phone-number')
      ) {
        viewFields.find('.contact-phone').text(
          $(field)
            .children()
            .last()
            .prev()
            .val()
        );
      } else if (
        $(field)
          .children()
          .last()
          .hasClass('ui-selectmenu-button')
      ) {
        viewFields.find('.contact-relation').text(formField);
      }
    });
  } // Helper function to toggle the first contact remove button

  function enableFirstRemove() {
    let firstContact;
    if ($('.authorized-contact').length > 1) {
      firstContact = $('.view-authorized-contact')
        .children('.authorized-contact')
        .eq(1);
    } else {
      firstContact = $('.view-authorized-contact')
        .children()
        .first('.authorized-contact:visible');
    }
    var removeBtns = firstContact.find('.remove-btn');
    var firstContactName = firstContact.find('.contact-name').text();
    var firstContactPhone = firstContact.find('.contact-phone').text();
    var infoText = firstContactName.concat(': ', firstContactPhone);
    if (
      firstContactName !== '' &&
      firstContactName !== null &&
      firstContactPhone !== '' &&
      firstContactPhone !== null
    ) {
      $('.authorized-contacts-text').text(infoText);
    } else {
      $('.authorized-contacts-text').text(authorizedZeroContact);
    }
    if ($('.authorized-contact').length > 1) {
      $(Object.values(removeBtns)[0]).prop('disabled', false);
      $(Object.values(removeBtns)[1]).prop('disabled', false);
    } else {
      $(Object.values(removeBtns)[0]).prop('disabled', true);
      $(Object.values(removeBtns)[1]).prop('disabled', true);
    }
  } // functions for when you save a contact

  function saveBtn(e) {
    var parent = $(e.currentTarget).parents('.view-authorized-contact');
    var form, saveURL;
    saveURL = `${ACC.config.encodedContextPath}${API_REFERENCE.accountAuthorizedContacts.saveAuthorizedContacts}`;
    parent.find('.authorized-contact').each(function(field, item) {
      //Using specific item from for loop instead of parent with index
      var viewField = $(item);
      var editForm = $(
        $(item).nextUntil("div[id ^='contact_']", '.account-information')
      );
      var editField = $(editForm).find('.edit-contact');

      if (!editField.hasClass('hidden')) {
        var firstName = $(editForm)
          .find('.fname')
          .val().trim();
        var lastName = $(editForm)
          .find('.lname')
          .val().trim();
        var phoneContact = $(editForm)
          .find('.contact-phone-number')
          .val();
        var relation = $(editForm)
          .find('.contact-relation')
          .val();
        const name = /^[a-zA-Z0-9\s'-]+$/;

        if (firstName !== '') {
          if (!name.test(firstName)) {
            $(editForm)
              .find('.error-msg-fName')
              .attr('hidden', false);
            $(editForm)
              .find('.fname')
              .addClass('error-msg-textbox');
            isfNameError = true;
          } else {
            $(editForm)
              .find('.error-msg-fName')
              .attr('hidden', true);
            $(editForm)
              .find('.fname')
              .removeClass('error-msg-textbox');
            isfNameError = false;
          }
        } else {
          $(editForm)
            .find('.error-msg-fName')
            .attr('hidden', false);
          $(editForm)
            .find('.fname')
            .addClass('error-msg-textbox');
          isfNameError = true;
        }

        if (lastName !== '') {
          if (!name.test(lastName)) {
            $(editForm)
              .find('.error-msg-lName')
              .attr('hidden', false);
            $(editForm)
              .find('.lname')
              .addClass('error-msg-textbox');
            islNameError = true;
          } else {
            $(editForm)
              .find('.error-msg-lName')
              .attr('hidden', true);
            $(editForm)
              .find('.lname')
              .removeClass('error-msg-textbox');
            islNameError = false;
          }
        } else {
          $(editForm)
            .find('.error-msg-lName')
            .attr('hidden', false);
          $(editForm)
            .find('.lname')
            .addClass('error-msg-textbox');
          islNameError = true;
        }

        if (phoneContact.length < 12 || phoneContact == '') {
          isPhnError = true;
          $(editForm)
            .find('.error-msg-number')
            .attr('hidden', false);
          $(editForm)
            .find('.contact-phone-number')
            .addClass('error-msg-textbox');
        } else {
          $(editForm)
            .find('.error-msg-number')
            .attr('hidden', true);
          $(editForm)
            .find('.contact-phone-number')
            .removeClass('error-msg-textbox');
          isPhnError = false;
        }

        if (relation == '' || relation == null) {
          isRelationError = true;
          $(editForm)
            .find('.error-msg-relation')
            .attr('hidden', false);
          $(editForm)
            .find('#Relation-button')
            .addClass('error-msg-textbox');
        } else {
          $(editForm)
            .find('.error-msg-relation')
            .attr('hidden', true);
          $(editForm)
            .find('#Relation-button')
            .removeClass('error-msg-textbox');
          isRelationError = false;
        }
        var authorizedContactId = $(editForm)
          .find('#authorizedContactId')
          .val();

        if (
          authorizedContactId === '' &&
          viewField.find('.authorized-contact-btns').data('contactId') !==
            undefined
        ) {
          authorizedContactId = viewField
            .find('.authorized-contact-btns')
            .data('contactId');
        }
        var data1 = {
          firstName: firstName,
          lastName: lastName,
          phoneContact: phoneContact,
          relationship: relation,
          authorizedContactId: authorizedContactId
        };

        if (!isfNameError && !islNameError && !isPhnError && !isRelationError) {
          if (!saveAuthContactAjaxReq) return false;
          saveAuthContactAjaxReq = false;
          formPostJsonResponse(saveURL, data1)
            .then(responseData => {
              saveAuthContactAjaxReq = true;
              const data = responseData;
              const authorizeContactId = String(
                data[data.length - 1].authorizedContactId
              );
              if (
                viewField.hasClass('hidden') &&
                !editField.hasClass('hidden')
              ) {
                viewField.toggleClass('hidden');
                editField.toggleClass('hidden');
                saveContactInfo(e, editField, viewField);
              }
              if (!$(parent.find('.edit-contact-btns')).hasClass('hidden')) {
                $(parent.find('.edit-contact-btns')).toggleClass('hidden');
              }
              if (
                viewField.find('.authorized-contact-btns').data('contactId') ===
                undefined
              ) {
                viewField
                  .find('.authorized-contact-btns')
                  .attr('data-contact-id', authorizeContactId);
              }
              if (
                viewField
                  .find('.authorized-contact-btns')
                  .data('customerId') === undefined
              ) {
                viewField
                  .find('.authorized-contact-btns')
                  .attr('data-customer-id', $('#customerID').val());
              }
              editContactAmount();
              enableFirstRemove();
            })
            .catch(() => {
              saveAuthContactAjaxReq = true;
            });
        }
      }
    });
  } // checks fields and enables save button when fields are correct

  var isfNameError = false;
  var islNameError = false;
  var isPhnError = false;
  var isRelationError = false;

  function validatePhoneError() {
    var otherFields = $(this)
      .parent()
      .parent()
      .children();
    if (otherFields.find('.contact-phone-number').val().length < 12) {
      isPhnError = true;
      otherFields.find('.error-msg-number').attr('hidden', false);
      otherFields.find('.contact-phone-number').addClass('error-msg-textbox');
    } else {
      otherFields.find('.error-msg-number').attr('hidden', true);
      otherFields
        .find('.contact-phone-number')
        .removeClass('error-msg-textbox');
      isPhnError = false;
    }
  }

  function validateRelationError() {
    var otherFields = $(this)
      .parent()
      .parent()
      .children();
    if (otherFields.find('.contactrelation').val() == '') {
      isRelationError = true;
      otherFields.find('.error-msg-relation').attr('hidden', false);
      otherFields.find('#Relation').addClass('error-msg-textbox');
    } else {
      otherFields.find('.error-msg-relation').attr('hidden', true);
      otherFields.find('#Relation').removeClass('error-msg-textbox');
      isRelationError = false;
    }
  }

  function validateFirstInput(e) {
    var otherFields = $(this)
      .parent()
      .parent()
      .children();
    const name = /^[a-zA-Z0-9\s'-]+$/;

    if (otherFields.find('.fname').val() !== '') {
      if (!name.test(otherFields.find('.fname').val())) {
        otherFields.find('.error-msg-fName').attr('hidden', false);
        otherFields.find('.fname').addClass('error-msg-textbox');
        isfNameError = true;
      } else {
        otherFields.find('.error-msg-fName').attr('hidden', true);
        otherFields.find('.fname').removeClass('error-msg-textbox');
        isfNameError = false;
      }
    } else {
      otherFields.find('.error-msg-fName').attr('hidden', false);
      otherFields.find('.fname').addClass('error-msg-textbox');
      isfNameError = true;
    }
  }
  function validateLastInput(e) {
    var otherFields = $(this)
      .parent()
      .parent()
      .children();
    const name = /^[a-zA-Z0-9\s'-]+$/;

    if (otherFields.find('.lname').val() !== '') {
      if (!name.test(otherFields.find('.lname').val())) {
        otherFields.find('.error-msg-lName').attr('hidden', false);
        otherFields.find('.lname').addClass('error-msg-textbox');
        islNameError = true;
      } else {
        otherFields.find('.error-msg-lName').attr('hidden', true);
        otherFields.find('.lname').removeClass('error-msg-textbox');
        islNameError = false;
      }
    } else {
      otherFields.find('.error-msg-lName').attr('hidden', false);
      otherFields.find('.lname').addClass('error-msg-textbox');
      islNameError = true;
    }
  }

  function openCollapsedSection(e) {
    e.preventDefault();
    if ($('.authorized-contact').length > 1) {
      $('.view-authorized-contact').toggleClass('section-bottom');
    }
    var $clicked = $(e.currentTarget);
    $('.authorized-contacts-text').toggleClass('hidden');
    $clicked.toggleClass('expanded');

    Object.keys($('.view-authorized-contact').children()).map(function(
      section
    ) {
      if ($(section).hasClass('authorized-contact')) {
        var phoneSection = $(section).children()[1];
        var contactNumber = $(phoneSection).text();
        if (contactNumber !== '') {
          contactNumber = contactNumber.replace(
            /(\d{3})(\d{3})(\d{4})/,
            '$1.$2.$3'
          );
          $(phoneSection).text(contactNumber);
        }
        if ($(section).hasClass('hidden')) {
          if ($('#contact_').length !== 1) {
            $(section).toggleClass('hidden');
            $(section)
              .next()
              .toggleClass('hidden');
          }
        }
      } else if ($(section).hasClass('edit-contact')) {
        if (
          $(section)
            .children()
            .find('.contact-name')
            .val().trim() === '' &&
          $(section)
            .children()
            .find('.contact-phone-number')
            .val() === '' &&
          $(section)
            .children()
            .find('.contact-relation')
            .val() === 'Sister'
        ) {
          $(section)
            .prev()
            .remove();
          $(section).remove();
        } else {
          var tempContacts = $(section).children('.edit-contact-fields');
          saveContactInfo(
            e,
            $(Object.values(tempContacts)[0]).children(),
            $(Object.values($(section).prev())[0])
          );
        }
      }
    });
    $('.authorized-contacts-list-view').slideToggle();
  }

  function removeEditForm(e) {
    e.preventDefault();

    var customerId = $(e.target)
      .parent()
      .parent()
      .parent()
      .find('.customerID')
      .val();
    var authorizedContactId = $(e.target)
      .parent()
      .parent()
      .parent()
      .find('.authorizedContactId')
      .val();
    var removeURL = removeAuthorizedContactUrl;
    var $editContact = $(e.target)
      .parent()
      .parent()
      .parent();
    var $editContactBtn = $editContact
      .parent()
      .parent()
      .find('.edit-contact-btns');
    if (!removeAuthContactFormAjaxReq) return false;
    removeAuthContactFormAjaxReq = false;
    const formData = {
      customerId: customerId,
      authorizedContactId: authorizedContactId
    };
    formPostJsonResponse(removeURL, formData)
      .then(data => {
        removeAuthContactFormAjaxReq = true;
        $($editContact).remove();
        if (!$editContactBtn.hasClass('hidden')) {
          $editContactBtn.toggleClass('hidden');
        }
        generateNewIds();
        var contactAmt = $('.authorized-contact').length;
        contactAmt = contactAmt - 2;
        if (contactAmt < 1) {
          $('.authorized-contacts-header-text').text('Authorized Contacts (0)');
          $('.view-authorized-contact').toggleClass('section-bottom');
        } else {
          $('.authorized-contacts-header-text').text(
            'Authorized Contacts (' + contactAmt + ')'
          );
        }
      })
      .catch(() => {
        removeAuthContactFormAjaxReq = true;
      });
    return false;
  }

  function removeContact(e) {
    e.preventDefault();
    var $removeContactBtn = $(e.target).parents('.authorized-contact-btns');
    var $removeContactRow = $(e.target).parents('.authorized-contact');
    var customerId = $removeContactBtn.data('customerId');
    var authorizedContactId = $removeContactBtn.data('contactId');
    if (!removeAuthContactNumberAjaxReq) return false;
    removeAuthContactNumberAjaxReq = false;
    const formData = {
      customerId: customerId,
      authorizedContactId: authorizedContactId
    };
    formPostJsonResponse(removeAuthorizedContactUrl, formData)
      .then(data => {
        removeAuthContactNumberAjaxReq = true;
        //remove related form as well
        $(
          $($removeContactRow).nextUntil(
            "div[id ^='contact_']",
            '.account-information'
          )
        ).remove();
        $($removeContactRow).remove();

        var contactAmt = $('.authorized-contact').length;
        contactAmt = contactAmt - 1;
        if (contactAmt > 0) {
          $('.authorized-contacts-header-text').text(
            'Authorized Contacts (' + contactAmt + ')'
          );
        } else {
          $('.authorized-contacts-header-text').text('Authorized Contacts (0)');
          $('.view-authorized-contact').toggleClass('section-bottom');
        }
        enableFirstRemove();
      })
      .catch(() => {
        removeAuthContactNumberAjaxReq = true;
      });
    return false;
  } // initial contact amount function

  function contactAmount() {
    var contactAmt = $('.authorized-contact').length;
    var namePhoneDetail = $('.authorized-contacts-text')
      .text()
      .trim();
    if (contactAmt > 0) {
      contactAmt = contactAmt - 1;
      var text = $('.authorized-contacts-header-text')
        .text()
        .concat(' (', contactAmt, ')');
      $('.authorized-contacts-header-text').text(text);
    }
    if (namePhoneDetail !== undefined && namePhoneDetail.length > 0) {
      var name = namePhoneDetail.split(':')[0];
      var phone = namePhoneDetail.split(':')[1];
      if (phone !== undefined && phone !== null) {
        phone = phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1.$2.$3');

        $('.authorized-contacts-text').text(name + ':' + phone);
      } else {
        $('.authorized-contacts-text').text(name);
      }
    }
  } // helper function for adding new contacts

  function bindEventsToEditContact(baseViewCode, baseEditCode) {
    var contactAmt = $('.authorized-contact').length + 1;
    $(baseViewCode).attr('id', 'contact_' + contactAmt);
    $(baseViewCode)
      .find('.contact-name')
      .text('');
    $(baseViewCode)
      .find('.contact-phone')
      .text('');
    $(baseViewCode)
      .find('.contact-relation')
      .val('');
    var baseContacts = $(Object.values($(baseEditCode))[0])
      .children()
      .first();
    Object.values(baseContacts).forEach(function(field) {
      $(field)
        .find('input')
        .attr('value', '');
      $(field)
        .find('input')
        .val('');
      $(field)
        .find('input')
        .val('');
    });
    $(
      $(baseViewCode)
        .clone()
        .addClass('hidden')
    ).insertBefore('.edit-contact-btns');
    $(
      $(baseEditCode)
        .clone()
        .toggleClass('hidden')
    ).insertBefore('.edit-contact-btns');
    $('.view-authorized-contact .account-information')
      .last()
      .find('.fname')
      .focus();
    generateNewIds();
    $('.edit-btn').on('click', editBtn);

    $('.contact-phone-number').on('keydown', changeNumber);

    $('.cancel-btn').on('click', cancelBtn);
    $('.fname').on('keyup', validateFirstInput);
    $('.lname').on('keyup', validateLastInput);

    $('.contact-phone-number').on('keyup', validatePhoneError);
  } // constants that help generate new contact fields

  var baseViewContact = $.parseHTML($('.view-authorized-contact').html())[1];
  var baseEditContact = $.parseHTML($('.view-authorized-contact').html())[3]; // add a new authorized contact

  function addNewContact(e) {
    e.preventDefault();
    bindEventsToEditContact(baseViewContact, baseEditContact);
    $('.edit-contact .contact-relation').selectmenu({
      classes: {
        'ui-selectmenu-button': 'col-xs-12 col-sm-12 mt-2 selectmenu-relation'
      },
      open: function() {
        iosSelectmenuAccessibilityFixes($(this));
      },
      close: function() {
        $(this)
          .next('.ui-selectmenu-button')
          .focus();
      }
    });
    if (
      $('.view-authorized-contact')
        .children('.edit-contact-btns')
        .hasClass('hidden')
    ) {
      $('.view-authorized-contact')
        .children('.edit-contact-btns')
        .toggleClass('hidden');
    }
  }

  $('.comm-pref-toggle').click(function(e) {
    e.preventDefault();
    var $clicked = $(e.currentTarget);
    $('.comm-pref-text').toggleClass('hidden');
    $clicked.toggleClass('expanded');

    if ($clicked.hasClass('expanded')) {
      $clicked.attr('aria-expanded', 'true');
    } else {
      $clicked.attr('aria-expanded', 'false');
    }

    $('.comm-pref-view').slideToggle();
  }); // order reminder modal trigger

  function modalTrigger(e) {
    e.preventDefault();
    var checkboxes = $('.order-reminders').find('.custom-checkbox:checked')
      .length;
    $('.ok-btn').data('checkBox', this);
    $('.footer-btns .cancel-btn').data('checkBox', this);

    if (checkboxes < 1) {
      if (!this.checked) {
        $('#confirmationModal').modal('show');
      }
    }
  }

  function confirmSelection() {
    var checkbox = $(this).data('checkBox');
    checkbox.checked = false;
    $('#confirmationModal').modal('hide');
  }

  function cancelSelection() {
    var checkbox = $(this).data('checkBox');
    checkbox.checked = true;
  } // Authorized Contact event handlers

  $('.communication-preferences-list-view').addClass('hide');
  function communicationSection() {
    $('.communication-preferences-list-view').toggleClass('hide');
  }

  function validateInputField(e) {
    var regExp = new RegExp("^[a-zA-Z 0-9'-]+$");
    return restrictInvalidCharacters(e, regExp);
  }
  function generateNewIds() {
    $('.contact-field .fname').each(function(i) {
      $(this).attr('id', 'fname' + i);
      $(this)
        .parent()
        .find('label')
        .attr('for', 'fname' + i);
    });
    $('.contact-field .lname').each(function(i) {
      $(this).attr('id', 'lname' + i);
      $(this)
        .parent()
        .find('label')
        .attr('for', 'lname' + i);
    });
    $('.contact-field .contact-phone-number').each(function(i) {
      $(this).attr('id', 'phoneNumber' + i);
      $(this)
        .parent()
        .find('label')
        .attr('for', 'phoneNumber' + i);
    });
  }
  generateNewIds();

  $('.authorized-contacts-header-text').ready(contactAmount);
  $('.edit-btn').on('click', editBtn);
  $(document).on('click', '.remove-btn', removeContact);
  $('.remove-form').on('click', removeEditForm);
  $('.contact-phone-number').on('keydown', changeNumber);
  $('.save-btn').on('click', saveBtn);
  $('.cancel-btn').on('click', cancelBtn);

  $('.fname').on('keyup', validateFirstInput);

  $('.lname').on('keyup', validateLastInput);
  $('.contact-phone-number').on('keyup', validatePhoneError);
  $('.add-new-text').on('click', addNewContact);
  $('.status-info-icon').tooltip();
  $('.accountMenuBody').on('click', setAccountMenuActive);
  $('.accountLinkToggle').on('click', toggleAccountMenu); // Communication Preferences event handlers

  $('[data-toggle="tooltip"]').tooltip();
  $('.order-reminders .custom-checkbox').on('change', modalTrigger);
  $('.ok-btn').on('click', confirmSelection);
  $('.footer-btns .cancel-btn').on('click', cancelSelection);
  $(document).on(
    'click',
    '.authorized-contacts-toggle-btn',
    openCollapsedSection
  );
  $(document).on(
    'click',
    '.communication-preferences-toggler',
    communicationSection
  );
  $(document).on(
    'keypress',
    '.contact-name.fname,.contact-name.lname',
    validateInputField
  );
  // To format authorized contact phone number
  $('.contact-phone').text((index, textString) => {
    return formatPhoneNumber(textString);
  });
  if ($(window).width() >= 1368) {
    $('.accountHeaderText').attr('role', 'presentation');
  }
});
